﻿import React, { useState, useEffect } from 'react';
import { Department } from '../../models/department';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';

import DataGrid, {
    Column,
    FilterRow,
    GroupPanel,
    Selection,
    HeaderFilter,
    Editing,
    Popup,
    Form,
    Toolbar,
    Item as ToolbarItem,
    Button as ColumnButton,
    Paging,
    Scrolling,
    SearchPanel,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

export interface Props {
    title: string;
}

export default function DepartmentsTableManagementForm(props: Props) {
    const [departments, setDepartments] =
        useState<Department[]>();

    const [toastVisible, setToastVisible] =
        useState<boolean>();

    const [toastMessage, setToastMessage] =
        useState<string>();

    const [toastType, setToastType] =
        useState<any>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getDepartments();
    }, []);

    const gridWidth = 'calc(90vw - 13em)';

    return (
        <div>
            <DataGrid width={gridWidth}
                height="65vh"
                keyExpr="departmentId"
                dataSource={departments ? departments : []}
                wordWrapEnabled={true}
                allowColumnResizing={true}
                columnResizingMode='widget'
                onRowValidating={onDepartmentRowValidating}
                rowAlternationEnabled={true}
                
                showRowLines={true}
                showBorders={true} >

                <LoadPanel enabled={true} />
                <Paging enabled={false} />
                <Selection mode='single' />
                <HeaderFilter visible={true} />
                <FilterRow visible={true} />
                <GroupPanel visible={false} />
                <SearchPanel visible={true} />
                <Scrolling columnRenderingMode='virtual' />

                <Column type="buttons" width={"5rem"}>
                    <ColumnButton name="edit" />
                </Column>

                <Column dataField='name' width='20%' />
                <Column dataField='description' width='80%' />

                <Toolbar>
                    <ToolbarItem location='before'>
                        <div className="pw-datagrid-toolbar-template">
                            <div className="pw-datagrid-toobar-title">{props.title}</div>
                        </div>
                    </ToolbarItem>
                    <ToolbarItem name="addRowButton" location='after' />
                    <ToolbarItem name="searchPanel" location='after' />
                </Toolbar>

                <Editing
                    mode="popup"
                    useIcons={true}
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={false} >

                    <Popup title={props.title} showTitle={true} width='80vw' height='80vh' />
                    <Form>
                        <Item dataField="name" colSpan={2} />
                        <Item dataField="description" colSpan={2} editorType="dxTextArea" editorOptions={{ height: "10rem" }} />
                    </Form>

                </Editing>
            </DataGrid >

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    async function onDepartmentRowValidating(e: any) {
        if (e.oldData) {
            let department = e.oldData as Department;

            if (department) {
                let updatedDepartment = { ...department, ...e.newData };

                await updateDepartment(updatedDepartment)
                    .then(() => {
                        showToast("Department updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Department");
                    });
            }
        }
        else {
            if (e.newData) {
                let department = e.newData as Department;

                if (department) {
                    await insertDepartment(department)
                        .then(data => {
                            showToast("Department saved", "success");
                            getDepartments();
                        })
                        .catch(res => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Department");
                        });
                }
            }
        }
    }

    async function getDepartments() {
        await CrudFunctions.getData("common/departments")
            .then((data) => {
                console.log(data);

                setDepartments(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Departments");
            });
    }

    async function insertDepartment(department: Department) {
        return await CrudFunctions.postData("common/department", department)
    }

    async function updateDepartment(department: Department) {
        return await CrudFunctions.putData("common/department", department)
    }

    //show/hide

    function onToastHiding() {
        setToastVisible(false);
        setToastMessage(undefined);
        setToastType(undefined);
    }

    function showToast(message: string, toastType: string) {
        setToastMessage(message);
        setToastType(toastType);
        setToastVisible(true);
    }

    //other

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}


